import { render, staticRenderFns } from "./IBreadcrumbs.vue?vue&type=template&id=2c108ea9&"
import script from "./IBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./IBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports